import { memo, useState } from "react";

import Button from "@mui/material/Button";

import { Finding } from "stores/FindingStore";

import IgnoreDialog from "./Dialogs/IgnoreDialog";
import UnignoreDialog from "./Dialogs/UnignoreDialog";

// -----------------------------------------------------------------------------

const IgnoreAction = memo(function IgnoreAction({
  ignored,
  finding,
}: IgnoreActionProps): JSX.Element {
  const [openIgnore, setOpenIgnore] = useState(false);
  const [openUnignore, setOpenUnignore] = useState(false);

  //
  return (
    <>
      <Button
        variant={ignored ? "contained" : "outlined"}
        size="small"
        onClick={() => (ignored ? setOpenUnignore(true) : setOpenIgnore(true))}
      >
        {ignored ? "Unignore" : "Ignore"}
      </Button>

      {openIgnore && (
        <IgnoreDialog finding={finding} onClose={() => setOpenIgnore(false)} />
      )}
      {openUnignore && (
        <UnignoreDialog
          finding={finding}
          onClose={() => setOpenUnignore(false)}
        />
      )}
    </>
  );
});

export default IgnoreAction;

// -----------------------------------------------------------------------------

interface IgnoreActionProps {
  ignored: boolean;
  finding: Finding;
}
